import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import InputRadio from 'modules/_shared/components/InputRadio';

import { HistoryMovementsViewProvider } from 'modules/_shared/components/HistoryMovementsView/context/HistoryMovementsViewContext';
import operationTypes from 'constants/operationTypes';
import HistoryMovementsView from 'modules/_shared/components/HistoryMovementsView';
import { useRenumerationModal } from '../context/RenumerationModalContext';
import { renumerationModes } from '../constants/renumerationModes';
import RenumerationByClassMode from './RenumerationByClassMode';
import AutomaticRenumerationMode from './AutomaticRenumerationMode';

const RenumerationMovementsView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useRenumerationModal();

  const hasHistoryMovements = data.historyMovements.length > 0;

  const handelChangeToAutomatic = () => {
    actions.handleChangeRenumerationMode(renumerationModes.AUTOMATIC);
  };

  const handelChangeToManualByPartners = () => {
    actions.handleChangeRenumerationMode(renumerationModes.MANUAL_BY_PARTNERS);
  };

  const handelChangeToManualByClasses = () => {
    actions.handleChangeRenumerationMode(renumerationModes.MANUAL_BY_CLASSES);
  };

  return (
    <div>
      <div className="form-group">
        <label className="form-label">
          {t('HowDoYouWantToAssignTheNe')} <MandatoryField />
        </label>

        <div className="row">
          <div className="col-md-4">
            <InputRadio
              id="automatic"
              checked={data.renumerationMode === renumerationModes.AUTOMATIC}
              label={t('AutomaticBySttok')}
              onChange={handelChangeToAutomatic}
              disabled={hasHistoryMovements}
            />
          </div>

          <div className="col-md-4">
            <InputRadio
              id="manual-partners"
              checked={
                data.renumerationMode === renumerationModes.MANUAL_BY_PARTNERS
              }
              label={t('ManualByPartners')}
              onChange={handelChangeToManualByPartners}
              disabled
            />
          </div>

          <div className="col-md-4">
            <InputRadio
              id="manual-classes"
              checked={
                data.renumerationMode === renumerationModes.MANUAL_BY_CLASSES
              }
              label={t('ManualByClasses')}
              onChange={handelChangeToManualByClasses}
              disabled={hasHistoryMovements}
            />
          </div>
        </div>
      </div>
      {data.renumerationMode === renumerationModes.MANUAL_BY_CLASSES && (
        <RenumerationByClassMode />
      )}
      {data.renumerationMode === renumerationModes.AUTOMATIC && (
        <AutomaticRenumerationMode />
      )}

      {hasHistoryMovements && (
        <div className="mt-4">
          <HistoryMovementsViewProvider
            historyMovements={data.historyMovements}
            operationType={operationTypes.RENUMERATION}
          >
            <HistoryMovementsView />
          </HistoryMovementsViewProvider>
        </div>
      )}
    </div>
  );
};

export default RenumerationMovementsView;
